<template>
  <portal v-if="render" selector="#level-settings-mounting-point">
    <div class="v-application">
      <PopupMenu :items="allMenuItems">
        <template v-slot:activator="{ on, attrs }">
          <IconButton
            text="Einstellungen"
            v-bind="attrs"
            v-on="on"
            :icon="mdiCog"
          ></IconButton>
        </template>
      </PopupMenu>
      <CloseableDialog
        v-model="customAttributesOpen"
        hash="null"
        :disable-hash="true"
      >
        <template v-slot:header>
          <Header2>Eigene Felder bearbeiten</Header2>
        </template>
        <CustomAttributesManagement
          style="width: 100%"
        ></CustomAttributesManagement>
      </CloseableDialog>
    </div>
  </portal>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, Ref, ref } from "vue"
import PopupMenu, {
  MenuItem,
} from "app/ui-primitives/menus/popup-menu/PopupMenu.vue"
import IconButton from "components/UI/IconButton.vue"
import { mdiCog } from "@mdi/js"
import CustomAttributesManagement from "app/modules/custom-attributes/CustomAttributesManagement.vue"
import { CustomAttributesClient } from "app/modules/custom-attributes/client"
import CloseableDialog from "components/UI/CloseableDialog.vue"
import Header2 from "app/ui-primitives/header/Header2.vue"

export default defineComponent({
  name: "LevelSettings",
  components: {
    Header2,
    CloseableDialog,
    CustomAttributesManagement,
    PopupMenu,
    IconButton,
  },
  setup() {
    const render = ref(false)
    const menuItems: Ref<MenuItem[]> = ref([])
    const levelId: Ref<number | null> = ref(null)
    const isSuperAdmin = ref(false)

    onMounted(() => {
      const mountingPoint = document.querySelector(
        "#level-settings-mounting-point"
      )
      if (mountingPoint) {
        const dataRaw = mountingPoint.getAttribute("data")
        const data = dataRaw ? JSON.parse(dataRaw) : {}
        menuItems.value = data.menu_items ?? []
        levelId.value = data.level_id ?? null
        render.value = true
        isSuperAdmin.value = data.is_super_admin ?? false
        CustomAttributesClient.loadContext(null, levelId.value)
      }
    })

    const additionalMenuItems: MenuItem[] = [
      {
        key: "custom-attributes",
        title: "Eigene Felder bearbeiten",
        clickHandler: () => {
          customAttributesOpen.value = true
        },
      },
    ]

    const allMenuItems = computed(() =>
      isSuperAdmin.value
        ? [...menuItems.value, ...additionalMenuItems]
        : menuItems.value
    )

    const customAttributesOpen = ref(false)

    return {
      mdiCog,
      allMenuItems,
      levelId,
      render,
      customAttributesOpen,
    }
  },
})
</script>
